'use client';

import { CircleHelp } from 'lucide-react';
import { useAuthSession } from '@/components/rbac/AuthSessionProvider';
import { useTutorial } from './TutorialProvider';

/**
 * Help button (R34) shown in the topbar. It appears only for LOGGED-IN users on
 * pages that have a tutorial, and relaunches that page's spotlight tour (manual
 * mode — one time, no persistence). Icon + one-word label ("Guía"). Not shown
 * on phones (< 640px).
 */
export function TutorialHelpButton() {
	const { user, status } = useAuthSession();
	const { launch, tutorialForCurrentPath } = useTutorial();
	if (status !== 'authenticated' || !user) return null;
	if (!tutorialForCurrentPath) return null;

	return (
		<button
			type="button"
			onClick={() => launch(tutorialForCurrentPath)}
			data-tutorial="home-help"
			aria-label="Ver la guía de esta página"
			title="Ver la guía de esta página"
			// Hidden on phones (tours are desktop-only). `display` lives in the class, not
			// in `style`: an inline `display` would override `max-sm:hidden`.
			className="inline-flex max-sm:hidden"
			style={{
				alignItems: 'center',
				gap: 6,
				height: 'var(--siiv-control-height, 32px)',
				padding: '0 12px',
				borderRadius: 10,
				border: '1px solid #e2e8f0',
				background: '#ffffff',
				color: '#475569',
				fontSize: 13,
				fontWeight: 600,
				cursor: 'pointer',
			}}
		>
			<CircleHelp size={16} />
			Guía
		</button>
	);
}
